import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {formatarCpf, formatarNomeProduto, formatarValorReal} from "../../../../utils/formatar";
import {Button, Col, FormGroup, Row} from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import moment from "moment";
import loading from '../../../../assets/images/ajax-loader.gif';
import PropTypes from "prop-types";
import { formatMarcaAlocacaoVigente } from "../../../../utils/functions";

@inject("store")
@observer
export class DetalhamentoMigracoesAnteriores extends Component {

    static propTypes = {
        textoNenhumResultado: PropTypes.string,
        titulo: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
    }

    nomeObjetoFormat(cell) {
        return _.get(cell, "nome") ? cell.nome: "";
    }

    dateFormat(cell) {
        return cell ? moment(cell).format("DD/MM/YYYY") : "";
    }

    acaoBotaoFormat = (cell, row) => {
        if (!row.botaoSincMediaPulse) return null;
        return (
            <Button
                title="Sincronizar MediaPulse"
                className="icon-button text-info"
                onClick={() => this.props.controller.sincronizarMediaPulse(row)}
            >
                <FontAwesome name="refresh" />
            </Button>
        );
    };

    render() {
        
        const options_table = {
            noDataText: this.props.controller.loadingGestorArDebito ? <img src={loading} alt="loading" className="loading"/> : this.props.textoNenhumResultado ? this.props.textoNenhumResultado : "Não há alocações registradas.",
        };

        return (
            <div>
                <div>
                    <h4>{this.props.titulo ? this.props.titulo : "Alocações"}</h4>
                    <BootstrapTable data={ this.props.controller.alocacoesProdutoMot } maxHeight='400px' striped hover condensed options={options_table}>
                        <TableHeaderColumn width='80' dataField='dataInicio' isKey columnTitle dataFormat={ this.dateFormat } tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Data início</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '180'} columnTitle dataField='status'  tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Status</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? '35%'  : '300'} columnTitle dataField='nomeProduto' tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Descrição da alocação</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '180'} columnTitle dataField='projeto' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Projeto</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='centroResultado' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Centro Resultado</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='finalidade' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Finalidade</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='sistemaAlocacao' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Sistema</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='centroCustoDebito' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Centro de Custo</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='gestorAprovador' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Gestor Aprovador</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '60'} dataField='botaoSincMediaPulse' dataFormat={this.acaoBotaoFormat} tdStyle={{ whiteSpace: 'normal', textAlign: 'center' }} thStyle={{ whiteSpace: 'normal' }}>Sinc. MediaPulse</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        )
    }
}